import {ApiClient} from '@hconnect/apiclient'
import {AggregatedStoppageRcfaAvailability} from '@hconnect/common/stoppages/types/stoppage.types'
import {Iso8601} from '@hconnect/common/types'
import {spawnErrorToast} from '@hm/fundamental'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../../consts'
import {DowntimeDashboardQueryKey} from '../../types'

const QueryPrefix = DowntimeDashboardQueryKey.RcfaAvailability

type Params = {
  plantId: string
  from: Iso8601
  to: Iso8601
}

export const useRcfaAvailability = (
  {plantId, from, to}: Params,
  options?: Omit<
    UseQueryOptions<AggregatedStoppageRcfaAvailability, AxiosError>,
    'queryKey' | 'queryFn'
  >
) => {
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)

  const query = useQuery<AggregatedStoppageRcfaAvailability, AxiosError>({
    queryKey: [QueryPrefix, plantId, from, to],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<AggregatedStoppageRcfaAvailability>(
        `/downtime-dashboard/${plantId}/stoppages/rcfa-availability`,
        {params: {from, to}, signal}
      )

      return response.data
    },
    ...options
  })

  useEffect(() => {
    if (query.error) {
      spawnErrorToast(t('message.failedToFetchRcfaAvailability'), {closeOnClick: true})
    }
  }, [query.error, t])

  return query
}
